import axios from 'axios';

const api = axios.create({ baseURL: `${process.env.REACT_APP_API_PATH}` });

export const previewInterest = (quarterEndDate) =>
  api.get('interest/preview', { params: { quarterEndDate } }).then(r => r.data);

export const postInterest = (quarterEndDate) =>
  api.post('interest/post', { quarterEndDate }).then(r => r.data);

export const getHistory = (top = 200) =>
  api.get('interest/history', { params: { top } }).then(r => r.data);